import axious from 'axios'
import { showLoading, hideLoading } from '../api/loading'
const service= axious.create({
  baseURL: 'https://ringstar.xhqj71.com/jeecg-boot/',
  // baseURL: 'http://q66uqq.natappfree.cc/jeecg-boot/',
  
  settimeout: 2000, //超时时间
  headers: {
      'x-access-token': window.sessionStorage.getItem('token'),
      'Content-Type': 'application/json'
  },
 
})

// // 添加请求拦截器
// service.interceptors.request.use(
//   (config) => {
//     config.headers['Content-Type'] = 'application/json'
//     console.log("请求的数据:", config);
//     return config;
//   },
//   (error) => {
//     // 对请求错误做些什么
//     return Promise.reject("出错", error);
//   }
// );

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    // console.log("返回的数据", response);
    return response;
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js